export interface IImageResizer {
  resize(file: File, options: ImageResizeOptions, image?: HTMLImageElement): Promise<File | undefined>
}

export abstract class BaseImageResizer implements IImageResizer {
  abstract resize(file: File, options: ImageResizeOptions, image?: HTMLImageElement): Promise<File | undefined>

  createFileName(file: File, type: ImageResizeOutputType): string {
    const filename = file.name.replace(/\.[^.]+$/, `.${this.getExtension(type)}`)
    return filename
  }

  getExtension(type: ImageResizeOutputType): string {
    switch (type) {
      case "image/jpeg":
        return "jpg"
      case "image/webp":
        return "webp"
      default:
        throw new Error(`Unsupported image type: ${type}`)
    }
  }

  toFile(blob: Blob, file: File, type: ImageResizeOutputType, prefix?: string): File {
    const filename = prefix ? `${prefix}_${this.createFileName(file, type)}` : this.createFileName(file, type)
    return new File([blob], filename, {
      type,
      lastModified: file.lastModified,
    })
  }
}

export type ImageResizeOutputType = "image/jpeg" | "image/webp"

export type ImageResizeServiceOptions = {
  imageSize: number
  type: ImageResizeOutputType
}

export type ImageResizeOptions = {
  width: number
  height: number
  type: ImageResizeOutputType
}
